<template>
	<ul class="numbered-select-group">
		<li v-for="(select, i) in selects" :key="`nsg-${i}`">
			<span class="numbered-select-group__number">{{ i + 1 }}</span>
			<div class="select">
				<select :disabled="isDisabled(i)" @change="updateSelect" v-model="items[i]" :data-index="i">
					<option :value="null">Brak</option>
					<template v-if="groups">
						<template v-for="group in groups">
							<optgroup
								v-if="optionsByGroup(select, group.name).length"
								:key="`nsg-${i}-${group.name}`"
								:label="group.fullName"
							>
								<option
									v-for="option in optionsByGroup(select, group.name)"
									:key="`nsg-${i}-${option.name}`"
									:value="option.name"
								>
									{{ formatName(option) }}
								</option>
							</optgroup>
						</template>
					</template>
					<template v-else>
						<option v-for="option in select" :key="`nsg-${i}-${option.name}`" :value="option.name">
							{{ formatName(option) }}
						</option>
					</template>
				</select>
			</div>
		</li>
	</ul>
</template>

<script>
import * as R from 'ramda';
import {formatPrice} from '../../common/helpers/format-price';

const isNotNull = x => x !== null;

export default {
	name: 'NumberedSelectGroup',
	components: {},
	computed: {
		items() {
			return this.$store.state.unitConfiguration[this.unitConfigurationProp];
		},
	},
	props: {
		selects: {
			type: Array,
			required: true,
		},
		groups: {
			type: Object,
		},
		unitConfigurationProp: {
			type: String,
			required: true,
		},
		configurationPropSetter: {
			type: String,
			required: true,
		},
		useOnlyFirstEnabledFeature: {
			type: Boolean,
			required: false,
			default: true,
		},
		isPriceDisplayed: {
			type: Boolean,
			required: false,
			default: true,
		},
		forcedDisableItems: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	methods: {
		updateSelect(e) {
			const index = Number(e.target.dataset.index);
			const {value} = e.target;

			const currentItems = this.items;

			const itemsWithReplacedValue = R.update(index, value || null, this.items);

			const itemsWithClearedValuesAfterwards = !value
				? itemsWithReplacedValue.map((item, i) => (i > index ? null : item))
				: itemsWithReplacedValue;

			this.$store.commit(
				`unitConfiguration/${this.configurationPropSetter}`,
				itemsWithClearedValuesAfterwards
			);
		},
		isDisabled(i) {
			if (this.forcedDisableItems.includes(this.items[i])) {
				return true;
			}
			if (!this.useOnlyFirstEnabledFeature) {
				return false;
			}
			const firstNullIndex = R.takeWhile(isNotNull, this.items).length;
			return firstNullIndex < i;
		},
		optionsByGroup(select, group) {
			return R.filter(R.propEq('group', group))(select);
		},
		formatName(option) {
			return this.isPriceDisplayed
				? `${option.fullName} - ${formatPrice(option.cost)}`
				: option.fullName;
		},
	},
	watch: {
		selects: function(newSelects, oldSelects) {
			if (newSelects.length < oldSelects.length) {
				this.$store.commit(
					`unitConfiguration/${this.configurationPropSetter}`,
					R.pipe(
						R.take(newSelects.length),
						R.concat(R.__, R.repeat(null, this.items.length - newSelects.length))
					)(this.items)
				);
			}
		},
	},
};
</script>
